import mobile from "is-mobile";
import { useBrowser } from "~/utils";

export function useIsMobile(tablet = true) {
  const browser = useBrowser();

  return (
    mobile({
      tablet,
    }) ||
    (browser?.getBrowserName() === "Safari" && navigator.maxTouchPoints > 0)
  );
}
